






import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import axios from '@/app/axios'
import { version } from '@/../package.json'

@Component
export default class AppVersion extends Vue {

  private serverVersion: string = ''

  get clientVersion() {
    return `v${version}`
  }

  private async fetchServerVersion() {
    var res = await axios.get<string>('appversion')
    this.serverVersion = res.data
  }

  private async mounted() {
    //if (authService.authenticated()) {
      await this.fetchServerVersion()
    //}
  }
}
